"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestStatus = exports.ApiHostName = exports.CommonTypes = exports.SocialApiTypes = exports.ReactionsApiTypes = exports.CommentsApiTypes = exports.FeedApiTypes = exports.ApiTypes = exports.WixApi = void 0;
var proto_generated_1 = require("./proto-generated");
exports.WixApi = proto_generated_1.wrapper.wix.api;
exports.ApiTypes = proto_generated_1.wrapper.wix.social.groups.api;
exports.FeedApiTypes = proto_generated_1.wrapper.wix.feed;
exports.CommentsApiTypes = proto_generated_1.wrapper.wix.comments;
exports.ReactionsApiTypes = proto_generated_1.wrapper.wix.reactions;
exports.SocialApiTypes = proto_generated_1.wrapper.wix.social;
exports.CommonTypes = proto_generated_1.wrapper.wix.common;
var ApiHostName;
(function (ApiHostName) {
    ApiHostName["WIX"] = "www.wix.com";
    ApiHostName["MANAGE_WIX"] = "manage.wix.com";
    ApiHostName["GROUPS"] = "groups.wixapps.net";
    ApiHostName["EDITOR"] = "editor.wix.com";
    ApiHostName["EDITORX"] = "editorx.com";
    ApiHostName["EDITORWIXAPPS"] = "editor.wixapps.net";
    ApiHostName["DEV_WIX_CODE"] = "dev.wix-code.com";
})(ApiHostName = exports.ApiHostName || (exports.ApiHostName = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["APPROVED"] = "APPROVED";
    RequestStatus["REJECTED"] = "REJECTED";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
//# sourceMappingURL=types.js.map